import React, { useMemo, ReactNode } from 'react';

import { Icon, TranslatedText, withComponent, useRouter, navigate, DrawerProvider } from '@sms/plasma-ui';

import app from '../../config/app.json';
import * as styled from './PageWithMenu.styles';
import { useSecurity } from '@sms/security-plasma-security-auth-sdk-react';

type PageWithMenuProps = {
  children: ReactNode;
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
const SUB_PATH = (window as any).plasma?.environment?.SUB_PATH ?? '/';
const PROCESSED_SUB_PATH = SUB_PATH.replace(/\/$/, '');

function prefixPath(path: string) {
  const treatedPath = path.replace(/^\//, '');
  return `${PROCESSED_SUB_PATH}/${treatedPath}`.replace(/\/\//g, '/');
}

function PageWithMenu(props: PageWithMenuProps) {
  const { children } = props;
  const { breadcrumb } = useRouter('breadcrumb');

  const permissions = Array.from(useSecurity().permissions);

  const title = useMemo(() => {
    const defaultSelectedKeys = breadcrumb.map((e) => e.route);
    return (
      <>
        <styled.Menu
          mode="horizontal"
          defaultSelectedKeys={defaultSelectedKeys}
          onClick={({ key }) => navigate(key)}
          style={{ fontSize: 16, fontWeight: 500 }}
          id="main-menu"
        >
          {permissions.includes('event.view') && (
            <styled.MenuItem key={prefixPath(`/${app.code}/events`)}>
              <Icon name="calendar-alt" prefix="far" />
              <TranslatedText textKey="app.menu.events" />
            </styled.MenuItem>
          )}

          {permissions.includes('task.view') && (
            <styled.MenuItem key={prefixPath(`/${app.code}/tasks`)}>
              <Icon name="tasks" prefix="far" />
              <TranslatedText textKey="app.menu.tasks" />
            </styled.MenuItem>
          )}

          {permissions.includes('process.view') && (
            <styled.MenuItem key={prefixPath(`/${app.code}/processes`)}>
              <Icon name="code-branch" prefix="far" />
              <TranslatedText textKey="app.menu.processes" />
            </styled.MenuItem>
          )}

          {permissions.includes('decision.view') && (
            <styled.MenuItem key={prefixPath(`/${app.code}/decisionTables`)}>
              <Icon name="table" prefix="far" />
              <TranslatedText textKey="app.menu.decisionTables" />
            </styled.MenuItem>
          )}

          {permissions.includes('rule.view') && (
            <styled.MenuItem key={prefixPath(`/${app.code}/rules`)}>
              <Icon name="sitemap" prefix="far" />
              <TranslatedText textKey="app.menu.rules" />
            </styled.MenuItem>
          )}

          {permissions.includes('report.view') && (
            <styled.MenuItem key={prefixPath(`/${app.code}/reports`)}>
              <Icon name="paste" prefix="far" />
              <TranslatedText textKey="app.menu.reports" />
            </styled.MenuItem>
          )}

          {permissions.includes('dashboard.view') && (
            <styled.MenuItem key={prefixPath(`/${app.code}/boards`)}>
              <Icon name="layer-group" prefix="far" />
              <TranslatedText textKey="app.menu.boards" />
            </styled.MenuItem>
          )}
        </styled.Menu>
      </>
    );
  }, [breadcrumb]);

  return (
    <DrawerProvider>
      {title}
      {children}
    </DrawerProvider>
  );
}

export default withComponent(PageWithMenu);
